import styled from "styled-components";

export const StyledWelcome = styled.div<{ themeColor: string }>`
    text-align: center;
    background-color: inherit;
    .des-skeleton {
        margin: 15px 0 30px;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
    }
    .btn-skeleton {
        width: calc(100% - 24px);
        margin:0 auto;
        margin-bottom:20px;
        .ant-skeleton {
            .ant-skeleton-paragraph {
                li {
                    width: 100%!important;
                    height:60px;
                    border-radius: 64px;
                }
            }
        }
    }
    .box_top {
        background-size: cover;
        background-position: bottom;
        padding-bottom: 80px;
        background-color: inherit;
        .welcome {
            line-height: 33px;
            color: ${(p) => p.themeColor};
            padding-top: 26px;
        }
        .desc {
            width: 80%;
            margin: 16px auto 44px auto;
            line-height: 30px;
            text-align: center;
            color: inherit;
        }
    }

    .group_images {
        transform: translateY(-50px);
        background-color: inherit;
        padding: 12px 0;
        .ant-skeleton {
            width: calc(100% - 24px);
            margin:0 auto;
            margin-top: 20px;
            .ant-skeleton-paragraph {
                li {
                    width: 100%!important;
                    height:365px;
                    border-radius: 14px;
                    margin-bottom: 20px;
                }
            }
        }
        img {
            width: 90vw;
            max-width: 435px;
            margin-top: 12px;
            height: 90vw;
            max-height: 435px;
            object-fit: cover;
            border-radius: 8px;
        }
    }
`;
